import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpConfigInterceptor } from './networking/interceptor/httpConfig';
import { HttpResponseInterceptor } from './networking/interceptor/httpResponse';
import { GlobalErrorHandler } from './helper/ErrorHandler';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideHttpClient(withInterceptors([HttpConfigInterceptor, HttpResponseInterceptor])),
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
]
};
